import { Button, Dialog, DialogActions, DialogContent, DialogTitle, Stack } from "@mui/material";
import Text from "../../../components/Text";
import PhoneNumber from "../../../components/PhoneNumber";
import Lang from "../../../components/Lang";

export default function EditNameDialog({open,setOpen,customer,setCustomer}){

  if(!open) return null;
  if(!setCustomer) console.log("here")
    return (
      <Dialog
        open={open}
        fullWidth
      >
        <DialogTitle>Edit Customers Details</DialogTitle>
        <DialogContent>
          <Stack spacing={2}>
            <Text
              label="Name"
              value={customer.name}
              setValue={(name) => setCustomer({ ...customer, name })}
              url={`/customers/${customer._id}`}
              field="name"
            ></Text>
            <PhoneNumber
              value={customer.phone}
              url={`/customers/${customer._id}`}
              field={"phone"}
              setValue={(phone) => setCustomer({ ...customer, phone })}
            />

            <PhoneNumber
              value={customer.phone2}
              url={`/customers/${customer._id}`}
              field={"phone2"}
              setValue={(phone2) => setCustomer({ ...customer, phone2 })}
              label="Zalo phone"
            />
            <Text
              label={<Lang w="address" />}
              value={customer.address}
              url={`/customers/${customer._id}`}
              field={"address"}
              setValue={(address) => setCustomer({ ...customer, address })}          
            />
          </Stack>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setOpen(false)}>Close</Button>
        </DialogActions>
      </Dialog>
    );
}